import { api } from '@/core/lib/api'
import { queryClient } from '@/core/lib/query-client'
import { clearAccessToken, setAccessToken } from '@/core/lib/token-store'
import type { TPermissionKey } from '@/core/types/permission'

import { AUTH_USER_KEY, authEndpoints } from '@/modules/auth/auth.constants'
import { authUserQueryOptions } from '@/modules/auth/auth.hooks'
import type { TAuthUser, TTokens } from '@/modules/auth/auth.types'

// Route guard'lar için: cache'ten ver; yoksa/iptal edilmişse yeniden çek. Hata → null.
export const getAuth = async (): Promise<TAuthUser | null> => {
  try {
    const cached = queryClient.getQueryData<TAuthUser>(AUTH_USER_KEY)
    const state = queryClient.getQueryState(AUTH_USER_KEY)
    if (cached && !state?.isInvalidated) {
      return cached
    }
    return await queryClient.fetchQuery(authUserQueryOptions())
  } catch {
    return null
  }
}

// Giriş sonrası: access token'ı belleğe al (refresh token httpOnly cookie'de, backend
// set etti), ardından kullanıcıyı (izinleriyle) yükle.
export const persistSignIn = async (tokens: TTokens): Promise<TAuthUser> => {
  setAccessToken(tokens.access_token)
  return queryClient.fetchQuery(authUserQueryOptions())
}

export const signOut = async (): Promise<void> => {
  // Backend refresh cookie'sini sildir; ağ hatası olsa da client tarafı temizlenir.
  try {
    await api.post(authEndpoints.signOut)
  } catch {
    // sessiz geç — cookie zaten geçersiz olabilir.
  }
  clearAccessToken()
  await queryClient.removeQueries({ queryKey: AUTH_USER_KEY })
}

export const hasPermission = async (
  permission: TPermissionKey
): Promise<boolean> => {
  const auth = await getAuth()
  return auth?.permissions?.includes(permission) ?? false
}

// Legacy re-export — yeni kod `@/core/lib/route-guards`'tan import etmeli.
export { routeHasPermission } from '@/core/lib/route-guards'
